import { Component, ViewChild, Output, EventEmitter, Input } from '@angular/core';

import { TabsComponent } from '../tabs/tabs.component';
import { SocketService } from '../../common/services/Socket.service';
import { TicketService } from '../../common/services/Ticket.service';

@Component({
  selector: 'my_tabs',
  templateUrl: 'mytab.component.html',
  styleUrls: ['mytab.css'],
  providers: [],
})
export class MytabComponent {
  @ViewChild('detailTemplate') detailTemplate;
  @ViewChild(TabsComponent) tabsComponent;

  @Input() force_new_tab;

  constructor(
    private socketService: SocketService,
    private ticketService: TicketService
  ) {
    const subscription = this.socketService.missionAnnounced$.subscribe(mission => {
      if (mission.action == 'open-tab') {
        const data = mission.data;
        switch (data.type) {
          case 'ticket': {
            if (data.action == 'new') {
              this.tabsComponent.openTab(
                'Ticket mới',
                this.detailTemplate,
                {
                  type: 'ticket',
                  action: 'new',
                  detail: data.detail ? data.detail : {},
                },
                true
              );
            } else if (data.action == 'edit' || data.action == 'ring') {
              let isExisted = false;
              for (let i = 0; i < this.tabsComponent.dynamicTabs.length; i++) {
                const tab = this.tabsComponent.dynamicTabs[i];
                if (tab.dataContext.detail && tab.dataContext.detail._id == data.detail._id) {
                  if (data.action == 'ring') {
                    tab.dataContext.action = data.action;
                    tab.dataContext.detail = data.detail;
                    if (data.detail && data.detail.receiver_id) {
                      tab.dataContext.detail.receiver_id = null;
                    }
                  }
                  this.tabsComponent.selectTab(tab);
                  isExisted = true;
                  break;
                }
              }
              if (!isExisted) {
                this.tabsComponent.openTab(
                  data.detail.subject,
                  this.detailTemplate,
                  {
                    type: 'ticket',
                    action: data.action,
                    detail: data.detail,
                  },
                  true
                );
              }
            }
            break;
          }
          case 'user': {
            const title = data.detail.name
              ? data.detail.name
              : data.detail.phone
                ? data.detail.phone
                : data.detail.email;
            let isExisted = false;
            for (let i = 0; i < this.tabsComponent.dynamicTabs.length; i++) {
              const tab = this.tabsComponent.dynamicTabs[i];
              if (tab.dataContext.detail && tab.dataContext.detail._id == data.detail._id) {
                this.tabsComponent.selectTab(tab);
                isExisted = true;
                break;
              }
            }
            if (!isExisted) {
              this.tabsComponent.openTab(
                title,
                this.detailTemplate,
                {
                  type: 'user',
                  action: 'edit',
                  detail: data.detail ? data.detail : {},
                },
                true
              );
            }
            break;
          }
          case 'organize': {
            const title = data.detail.name;
            let isExisted = false;
            for (let i = 0; i < this.tabsComponent.dynamicTabs.length; i++) {
              const tab = this.tabsComponent.dynamicTabs[i];
              if (tab.dataContext.detail && tab.dataContext.detail._id == data.detail._id) {
                this.tabsComponent.selectTab(tab);
                isExisted = true;
                break;
              }
            }
            if (!isExisted) {
              this.tabsComponent.openTab(
                title,
                this.detailTemplate,
                {
                  type: 'organize',
                  action: 'edit',
                  detail: data.detail ? data.detail : {},
                },
                true
              );
            }
            break;
          }
          default:
            break;
        }
      } else if (mission.action == 'edit-tab') {
        const data = mission.data;
        for (let i = 0; i < this.tabsComponent.dynamicTabs.length; i++) {
          const tab = this.tabsComponent.dynamicTabs[i];
          if (tab.tabIndex == data.tabIndex) {
            tab.dataContext.action = data.action;
          }
        }
      }
    });
  }

  openNew(event) {
    if (event) {
      this.tabsComponent.openTab('Ticket mới', this.detailTemplate, { type: 'ticket', action: 'new' }, true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/mytab/mytab.component.ts